import React from 'react'
import CatagoryWidget from "../../blog/CatagoryWidget";
import BannerWidget from "../../blog/BannerWidget";
import BlogDetailsContent5 from '../Etapeledigitalizarii/BlogDetailsContent5';


function BlogDetailsWrap5() {
  return (
    <>
      <div className="blog-details-area sec-mar-top">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <BlogDetailsContent5 />
            </div>
            <div className="col-lg-4">
              <CatagoryWidget />
              <BannerWidget />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default BlogDetailsWrap5